module.exports = __webpack_public_path__ + "img/archive-book.194abdb5.svg";